import { defineComponent as n, onMounted as r, nextTick as i } from "vue";
import o from "postscribe";
const m = n({
  name: "DynamicLogo",
  props: {
    dynamicContent: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    className: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const e = t.id + Math.random().toString(36).substr(2, 10);
    return r(() => {
      i(function() {
        o("#" + e, t.dynamicContent);
      });
    }), { uniqueId: e };
  }
});
export {
  m as default
};
//# sourceMappingURL=index13.js.map
